<template>
  <div class="inputFields">
    <header class="demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600">
      <div class="mdl-layout__header-row">

        <span class="mdl-layout-title">Input Fields</span>
        <div class="mdl-layout-spacer"></div>

      </div>
    </header>

    <InputLanguages></InputLanguages>

  </div>
</template>

<script>
  import InputLanguages from "./config/InputLanguages.vue"

  export default {
    name: "InputFields",
    components: { InputLanguages },

  }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// InputFields.vue?0133a481